export const DELIVERY_SHIPPING_CONFIG = {
    PROCESSING: {
        label: "Processing",
        color: "#1E40AF", bg: "#EFF6FF", border: "#BFDBFE", dot: "#3B82F6",
        iconName: "solar:settings-bold",
    },
    SHIPPED: {
        label: "Shipped",
        color: "#0C4A6E", bg: "#F0F9FF", border: "#BAE6FD", dot: "#0EA5E9",
        iconName: "solar:delivery-bold",
    },
    DELIVERED: {
        label: "Delivered",
        color: "#065F46", bg: "#ECFDF5", border: "#A7F3D0", dot: "#10B981",
        iconName: "solar:box-bold",
    },
    RETURNED: {
        label: "Returned",
        color: "#6B21A8", bg: "#FAF5FF", border: "#E9D5FF", dot: "#A855F7",
        iconName: "solar:undo-left-bold",
    },
    OUTFORDELIVERY: {
        label: "Out for Delivery",
        color: "#1E3A8A", bg: "#EFF6FF", border: "#BFDBFE", dot: "#2563EB",
        iconName: "solar:map-bold",
    },
}